<div class="inline-flex flex-col" id="page-content" data-focus-on-load="true" tabindex="-1">
   <div class="p-5">
      <app-go-back></app-go-back>
   </div>
   <div class="overflow-auto">
      <router-outlet></router-outlet>
   </div>
</div>